import { render, staticRenderFns } from "./MemberOrderConfirmation.vue?vue&type=template&id=64d7dd9c&scoped=true"
import script from "./MemberOrderConfirmation.vue?vue&type=script&lang=js"
export * from "./MemberOrderConfirmation.vue?vue&type=script&lang=js"
import style0 from "./MemberOrderConfirmation.vue?vue&type=style&index=0&id=64d7dd9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7dd9c",
  null
  
)

export default component.exports